/// <reference types="@angular/localize" />

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  APP_INITIALIZER,
  enableProdMode,
  importProvidersFrom,
  // isDevMode,
} from "@angular/core";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from "@angular/router";
// import { provideServiceWorker } from "@angular/service-worker";
import { PureAbility } from "@casl/ability";
import { ELocalStorage } from "@core/enums/LocalStorage.enum";
import { AuthInterceptor } from "@core/interceptor/auth.interceptor";
import { AppAbility } from "@core/interfaces/ability.interface";
import { LocalService } from "@core/services/local-storage.service";
import { environment } from "@environments/environment";
import { AuthService } from "@modules/auth/services/auth.service";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg-2";
import { provideNgxMask } from "ngx-mask";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app/app.component";
import { appRoutes } from "./app/app.routes";
import { DatePipe } from "@angular/common";

function appInitializer(
  _authService: AuthService,
  _localStorageService: LocalService
) {
  return () => {
    return new Promise<void>((resolve) => {
      const perms = _localStorageService.getData(ELocalStorage.PERMISSIONS);
      const access_token = _localStorageService.getData(
        ELocalStorage.ACCESS_TOKEN
      );
      if (perms && access_token) {
        _authService.updateAbility(perms);
      }
      resolve();
    });
  };
}
if (environment.production) {
  enableProdMode();
}
bootstrapApplication(AppComponent, {
  providers: [
    DatePipe,
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: "reload",
      })
    ),
    importProvidersFrom(
      BrowserModule,
      TranslateModule.forRoot(),
      InlineSVGModule.forRoot(),
      ToastrModule.forRoot({
        timeOut: 5000,
        extendedTimeOut: 5000,
        closeButton: true,
        enableHtml: true,
        maxOpened: 3,
      })
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService, LocalService],
    },
    provideNgxMask({ validation: false }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: AppAbility, useValue: new AppAbility() },
    { provide: PureAbility, useExisting: AppAbility },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    // provideServiceWorker("ngsw-worker.js", {
    //   enabled: !isDevMode(),
    //   registrationStrategy: "registerWhenStable:30000",
    // }),
  ],
}).catch((err) => console.error(err));
